import SwipeableModal from './SwipeableModal';

export default SwipeableModal;
